// Mirrors the backend RequestOriginTaskType enum
export const RequestOriginTaskType = {
    NOT_SET: 0,
    CODING: 1,
    CODING_QA: 2,
    IMAGE_EDITING: 3,
    IMAGE_EDITING_QA: 4,
    FINAL_QA: 5,
    BRAND_VERIFIED_QA: 6,
};

const REQUEST_ORIGIN_BY_SOURCE_PAGE = {
    coding: RequestOriginTaskType.CODING,
    codingqa: RequestOriginTaskType.CODING_QA,
    imageediting: RequestOriginTaskType.IMAGE_EDITING,
    imageeditingqa: RequestOriginTaskType.IMAGE_EDITING_QA,
    finalqa: RequestOriginTaskType.FINAL_QA,
    brandverifiedqa: RequestOriginTaskType.BRAND_VERIFIED_QA,
};

export const getRequestOriginTaskType = (taskSourcePage) => REQUEST_ORIGIN_BY_SOURCE_PAGE[taskSourcePage] ?? RequestOriginTaskType.NOT_SET;
